export default __webpack_public_path__ + "static/media/45t.69874f57.jpg";